import styles from "./Warning.module.css";


export function Warning(props) {
  const formatPhoneNumber = (phone) => {
    const cleaned = phone.toString().replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phone;
  };
  return (
    <>
      <section className={styles.warningsection}>
        <div className={styles.nowindowstickerwarning}>
          <div className={styles.ymmt}>{ props.year } { props.make } { props.model} { props.trim }</div>
          <p>There is no Interactive Window Sticker available for this vehicle. To request one, please contact the dealership at: 
            <a href={`tel:+${props.phone}`} className={styles.phonelink}>
              {formatPhoneNumber(props.phone)}
            </a>
            <br/>
          </p>
        </div>
      </section>
    </>
  );
}
